import {VeBoxEquipmentFilters} from "./data/models/VeBoxEquipmentFilters";

export enum EQ_TABLES_NAMES {
    CODE = "Code",
    NAME = "Name",
    MODEL = "Model",
    LOCATION = "Location",
    SINCE = "Since",
    REMOVE = "",
    ALL = "All",
    ACTION = "ACTION",
    FINAL_ACTION = "finalAction",
}

export enum EQ_TABLES_INDEXES {
    CODE = "code",
    NAME = "name",
    MODEL = "model",
    LOCATION = "location",
    SINCE = "since",
    REMOVE = "remove",
    ALL = "all",
    ACTION = "action",
    FINAL_ACTION = "finalAction",
}

export const enum ALARM_STATUS {
    PENDING,
    MANAGED,
    RECENTLY_CLOSED,
    CLOSED,
}

export const UNAUTHORIZED_MOVEMENT_ALARMS_GUID =
    "ce73f8ae-5293-11e8-b9a0-525400c5f801";

export const enum DEFAULT_EXCLUSION_FILTERS {
    UNAUTHORIZED_MOVEMENT_ALARMS,
    IN_WRITTEN_OFF_OR_MISSING_STATUS,
    IN_UNREGISTERED_LOCATION,
    IN_WAREHOUSE,
}

export const enum ADDITIONAL_FILTERS {
    KEY,
    COMPONENT_MODEL,
    DEVICE_MODELS,
    LOCATION_GENERIC_LABEL,
    HIERARCHY,
    COMMERCIAL_HIERARCHY,
}

export enum EQUIPMENT_STATUS {
    MISSING_GUID_STR = "9e2f66f1-a255-40d6-85eb-9457f93a607f",
    WRITTEN_OFF_STR = "b15c1d2a-ce2e-4747-a750-702c7b464f0a",
}

export enum DEVICE_TYPE {
    VBCTK = "88aa82ea-414d-11e8-838f-9418826ed820",
    OCTO = "34ad1a7a-77b7-4d3c-9469-9987535c0d31",
    SOLO = "1926ac0f-ec7f-4577-a55f-3777b5ee8bcb",
}

export enum EQUIPMENT_CATEGORY {
    COOLER = "4c6cb6e8-c7bf-11e7-ad82-525400c5f801",
    FREEZER = "4c6cb7a6-c7bf-11e7-ad82-525400c5f801",
}

export const baseFilter: VeBoxEquipmentFilters = {
    deviceFiltersCategory: {
        installed: true,
        deviceTypeGuids: [DEVICE_TYPE.VBCTK, DEVICE_TYPE.OCTO, DEVICE_TYPE.SOLO],
    },
    equipmentFiltersCategory: {
        categoryGuids: [EQUIPMENT_CATEGORY.COOLER, EQUIPMENT_CATEGORY.FREEZER],
    },
};
